const FndUserQueryFields = [
    {
        name: '路径',
        code: 'path',
        column: true,
        defaultFilter: true,
        width: 250
    },
    {
        name: '名称',
        code: 'name',
        column: true,
        defaultFilter: true,
        width: 150
    },
    {
        name: '请求方法',
        code: 'method',
        align: 'center',
        column: true,
        defaultFilter: true,
        width: 100
    },
    {
        name: '保护级别',
        code: 'protectLevel',
        column: true,
        defaultFilter: true,
        width: 100
    },
    {
        name: '权限组',
        code: 'permissionName',
        sortable:false,
        column: true,
        defaultFilter: true,
        width: 100
    },
    {
        name: 'java方法',
        code: 'clazz',
        width: 50,
        column: false,
        defaultFilter: true,
    }
]
export default FndUserQueryFields;